module.exports = __webpack_public_path__ + "static/media/README.f1bdd7b9.md";